exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.people-navbar[data-v-e8e6a3ba]{\n  position: fixed;\n  margin: -12px 0px 0px -12px;\n  width: calc(100% - 80px);\n  max-width: calc(100% - 80px);\n  z-index: 8;\n}\n.space[data-v-e8e6a3ba]{\n  width: 78px;\n}\n.view-sheet-icon[data-v-e8e6a3ba]{\n  margin-top: 10px;\n  margin-left: 30px;\n}\n.back-icon[data-v-e8e6a3ba]{\n  margin-right: 15px;\n}\n.people-logo[data-v-e8e6a3ba]{\n  text-transform: uppercase;\n  color: rgb(100, 100, 100);\n  font-weight: bold;\n}\n.active-logo[data-v-e8e6a3ba]{\n  margin-left: 80px;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8e6a3ba","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/People/PeopleNavigation.vue
// module id = AQSN
// module chunks = 1